
export default {
    namespaced: true,
	state: {
        alertMessage: null,
		isLoading: 0,
		title: '',
		fullHeight: false,
	},
	getters: {
	},
	mutations: {
		setAlertMessage(state, alertMessage) {
			state.alertMessage = alertMessage
		},
		showLoader(state) {
			state.isLoading++
			//console.log('show', state.isLoading)
		},
		hideLoader(state, force = false) {
			state.isLoading = force ? 0 : Math.max(0, --state.isLoading)
			//console.log('hide', state.isLoading)
		},
		setTitle(state, title) {
			state.title = title
		},
		setFullHeight(state, fullHeight) {
			state.fullHeight = fullHeight
		},
	},
	actions: {
        alert({ commit }, message = null) {
			commit('setAlertMessage', message)
		},
		showLoader({ commit }) {
			commit('showLoader')
		},
		hideLoader({ commit }, force = false) {
			commit('hideLoader', force)
		},
		title({ commit }, title) {
			commit('setTitle', title)
		},
		fullHeight({ commit }, fullHeight) {
			commit('setFullHeight', fullHeight)
		},
    },
}
